import React from "react";
import Solutions from "./solutions";
import AnimatedElement from "../../components/content/textAnimation/page";
import MarqueeSection from "./marqueeSection";
import ScheduleDemo from "./scheduleDemo";
import { RouteNavigation } from "../../Routes";
import { NavLink } from "react-router-dom";
import ScheduleDemoButton from "../../components/content/demoButton/customButton";
import SolutionSlider from "./solutionCarousel";
import DeviceListing from "../../components/content/deviceListing";

function Home() {
  return (
    <div>
      <SolutionSlider />
      <div className="max-w-screen-xl mx-auto p-4 min-[400px]:py-12 sm:py-24">
        <AnimatedElement animationClass="animate__fadeInDown" delay={0}>
          <h2 className="text-center mb-5 min-[400px]:mb-10 text-2xl min-[400px]:text-4xl poppins_regular">
            Mobi POS Devices
          </h2>
        </AnimatedElement>
        <DeviceListing />
      </div>
      <div className="container mx-auto">
        {/* <PosDevice /> */}
        <div>
          <div className="w-full md:w-[60%] px-2 space-y-8">
            <AnimatedElement animationClass="animate__bounce" delay={0}>
              <h2 className="poppins_regular text-3xl sm:text-5xl animate__animated animate__bounce">
                Next Gen Billing Machine
              </h2>
            </AnimatedElement>
            <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
              <p className="text-justify poppins_regular leading-10 tracking-wider animate__animated animate__fadeInLeft">
                Mobi POS is a revolution in Android Billing and Inventory
                Management. Mobi POS helps you to manage your Products,
                Customers, Vendors & Stock in a smart way and can maintain your
                van sales and multiple sales outlets simultaneously.
              </p>
            </AnimatedElement>
          </div>

          <div className="flex flex-col md:flex-row py-3 md:py-14 gap-5 px-2 w-full md:w-3/4 m-auto">
            <div className="w-full md:w-1/2 order-2 md:order-1 mt-0 md:mt-28">
              <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
                <h2 className="poppins_regular text-3xl sm:text-4xl">
                  Get Real-Time Reports Instantly
                </h2>
                <p className="poppins_regular text-sm/7 py-2">
                  Experience immediate access to live reports on sales,
                  inventory, and customer data.
                </p>
                <ul className="list-none pl-0 poppins_light">
                  <li className="relative mb-5 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span>Instant Sales Tracking</span>
                  </li>
                  <li className="relative mb-5 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span>Live Inventory Updates</span>
                  </li>
                  <li className="relative mb-2 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span>Customer Insights</span>
                  </li>
                </ul>
              </AnimatedElement>
            </div>
            <div className="w-full md:w-1/2 order-1 md:order-2">
              <AnimatedElement animationClass="animate__fadeInRight" delay={0}>
                <img
                  src={"images/home/Group 253.svg"}
                  alt="Real-Time Reports"
                  className="w-full h-auto"
                />
              </AnimatedElement>
            </div>
          </div>

          <div className="flex flex-col md:flex-row  md:py-14 gap-5 px-2 w-full md:w-3/4 m-auto mb-6 ">
            <div className="w-full md:w-1/2 order-2 md:order-1 mt-10">
              <AnimatedElement animationClass="animate__fadeInLeft" delay={0}>
                <img
                  src="/images/xenia_mobi_logo.png"
                  alt="xenia_mobi_logo"
                  className="w-40 mb-2"
                />
                <h2 className="poppins_regular text-3xl sm:text-4xl">
                  2-in-1 Billing Solution
                </h2>
                <p className="poppins_regular text-sm/7 lg:text-sm/7 py-2">
                  Handle restaurant and van sales operations with ease using one
                  powerful app.
                </p>
                <ul className="poppins_light list-none pl-0 mb-3">
                  <li className="relative mb-5 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span>Streamline Operations</span>
                  </li>
                  <li className="relative mb-5 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span> Accurate Inventory</span>
                  </li>
                  <li className="relative mb-2 flex items-center space-x-2 pl-6">
                    <img
                      src="/images/Icons/Group.svg"
                      alt="Customer Insights"
                      className="w-4 h-4"
                    />
                    <span>Efficient Billing</span>
                  </li>
                </ul>
              </AnimatedElement>
            </div>
            <div className="w-full md:w-1/2 order-1 md:order-2 m-auto">
              <AnimatedElement animationClass="animate__fadeInRight" delay={0}>
                <img
                  src={"images/home/Group 325.svg"}
                  alt="sss"
                  className="w-full m-auto"
                />
              </AnimatedElement>
            </div>
          </div>
        </div>
        <Solutions />
        <div className="flex flex-col justify-center items-center h-52 sm:h-60 md:h-72">
          <h2 className="poppins_regular text-2xl sm:text-5xl mb-10">
            Our Hardware Partners
          </h2>
          <div className="flex gap-20">
            <img
              className="w-20 sm:w-40 scale-100 hover:scale-150 transform duration-500"
              src="/images/imin_logo.svg"
              alt="imin_logo"
            />
            <img
              className="w-28 sm:w-48 scale-100 hover:scale-150 transform duration-500"
              src="/images/bpos_logo.svg"
              alt="bpos_logo"
            />
          </div>
        </div>
        <ScheduleDemo />
        <div className="max-w-[1024px] mx-auto text-center py-8 min-[480px]:py-16">
          <h2 className="text-[#232155] text-xl poppins_semibold mb-10">
            Our results in numbers
          </h2>
          <div className="flex flex-wrap gap-y-4 items-center">
            <div className="w-1/2 md:w-1/4">
              <h2 className="text-3xl sm:text-4xl poppins_bold text-[#232155]">
                10<span className="text-[#006CF0]">K+</span>
              </h2>
              <h3 className="poppins_semibold text-xs sm:text-base">
                Active users
              </h3>
            </div>
            <div className="w-1/2 md:w-1/4">
              <h2 className="text-3xl sm:text-4xl poppins_bold text-[#232155]">
                98<span className="text-[#006CF0]">%</span>
              </h2>
              <h3 className="poppins_semibold text-xs sm:text-base">
                Accuracy
              </h3>
            </div>
            <div className="w-1/2 md:w-1/4">
              <h2 className="text-3xl sm:text-4xl poppins_bold text-[#232155]">
                99<span className="text-[#006CF0]">%</span>
              </h2>
              <h3 className="poppins_semibold text-xs sm:text-base">
                Customer Satisfaction
              </h3>
            </div>
            <div className="w-1/2 md:w-1/4">
              <h2 className="text-3xl sm:text-4xl poppins_bold text-[#232155]">
                15<span className="text-[#006CF0]">Years</span>
              </h2>
              <h3 className="poppins_semibold text-xs sm:text-base">
                Of Journey
              </h3>
            </div>
          </div>
        </div>
      </div>
      <MarqueeSection />
      <div className="relative w-full">
        <img className="w-full" src="/images/home/banner_01.svg" alt="banner" />
        <div className="absolute inset-0 w-full flex items-center">
          <div className="flex justify-between px-2 w-full sm:w-3/4 m-auto items-center">
            <p className="poppins_light text-xs min-[480px]:text-[20px] sm:text-[24px] lg:text-[48px] text-white leading-[1.2]">
              Get Started with <br />
              <span className="poppins_bold">Mobi POS</span> Today!
            </p>
            <ScheduleDemoButton
              borderColor="white"
              textColor="white"
              bgColor="black"
              hoverColor="white"
            >
              <NavLink to={RouteNavigation.ScheduleDemo}>
                Book Free Demo
              </NavLink>
            </ScheduleDemoButton>
          </div>
        </div>
      </div>
      <div className="relative w-full text-white min-h-36">
        <img
          className="w-full h-full min-h-44 sm:h-auto object-cover"
          src="/images/home/banner_02.svg"
          alt="banner"
        />
        <div className="absolute inset-0 top-0 w-full flex flex-col items-center justify-start sm:justify-center gap-y-0 lg:gap-y-5 py-2">
          <div className="w-full lg:w-[60%] mx-auto text-center">
            <h2 className="poppins_medium text-sm sm:text-xl md:text-3xl mb-2 sm:mb-4">
              Download Xenia Mobi App
            </h2>
            <p className="poppins_light tracking-wider leading-4 md:leading-8 font-thin text-[8px] sm:text-sm">
              Xenia Mobi is versatile billing software for restaurants, retail,
              cafeterias, and distribution sectors. It streamlines GST/VAT
              accounting, enhancing efficiency and accuracy for diverse
              businesses.
            </p>
          </div>
          <div className="flex items-center mt-2">
            <a href="https://play.google.com/store/search?q=xenia%20mobi&c=apps&hl=en">
              <img
                className="w-20 sm:w-28"
                src="/images/elements/google-play.svg"
                alt="google_play_icon"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Home;
